import { z } from 'zod';
export const reportBlockSchema = z.object({
    key: z.string().min(1),
    title: z.string(),
    kind: z.enum(['data', 'ai', 'mixed']),
    markdown: z.string(),
    dataSnapshot: z.unknown().optional(),
    editedByUser: z.boolean().optional(),
});
export const reportContentV2Schema = z.object({
    schemaVersion: z.literal(2),
    scheme: z.enum(['TOP', 'TAP', 'ECO']),
    templateKey: z.string(),
    blocks: z.array(reportBlockSchema),
    generatedAt: z.string(),
    aiGenerated: z.boolean(),
});
/**
 * 判斷 content 是否為舊版（v1 5 章節）形狀。
 * 舊版沒有 schemaVersion，且帶 basicInfo/auditScope 等鍵。
 */
export function isLegacyContent(content) {
    if (!content || typeof content !== 'object')
        return false;
    const obj = content;
    if (obj.schemaVersion === 2)
        return false;
    return 'basicInfo' in obj || 'auditScope' in obj || 'conformityAssessment' in obj;
}
/** Zod schema：對應 AiGenerationLogDto，用於 API 回應校驗與前端 parse */
export const aiGenerationLogDtoSchema = z.object({
    id: z.number(),
    caseId: z.number(),
    reportId: z
        .number()
        .nullable()
        .optional()
        .transform((v) => v ?? null),
    jobId: z
        .number()
        .nullable()
        .optional()
        .transform((v) => v ?? null),
    scene: z.string(),
    blockKey: z
        .string()
        .nullable()
        .optional()
        .transform((v) => v ?? null),
    kind: z
        .string()
        .nullable()
        .optional()
        .transform((v) => v ?? null),
    model: z
        .string()
        .nullable()
        .optional()
        .transform((v) => v ?? null),
    status: z.string(),
    systemPrompt: z
        .string()
        .nullable()
        .optional()
        .transform((v) => v ?? null),
    userPrompt: z
        .string()
        .nullable()
        .optional()
        .transform((v) => v ?? null),
    output: z
        .string()
        .nullable()
        .optional()
        .transform((v) => v ?? null),
    errorMessage: z
        .string()
        .nullable()
        .optional()
        .transform((v) => v ?? null),
    latencyMs: z
        .number()
        .nullable()
        .optional()
        .transform((v) => v ?? null),
    createdAt: z.string(),
});
